module.exports = __webpack_public_path__ + "img/lg_ring_g_0_null_null@3x.a511a772.png";